
<section class="tags__singleTags">
  <div class="singleTags__wrapper">
    <div class="singleTags__title-wrapper">
      <ci-icon 
        class="singleTags__icon"
        type="svg" 
        name="shopping-mode" 
        scale="1.5x"
      ></ci-icon>
      
      <h3 class="ci-heading-h3-s-bold singleTags__title">
        {{ (this.isOnlySingleTags() ? 'Etiquetas' : 'Otras etiquetas') | translate }}
      </h3>
    </div>

    <ci-chip-set 
      #singleTagsChipSet
      class="singleTags__chip-set"
    >
      @for(tag of singleTagList(); track tag.id) {
        <ci-suggestion-chip-outline>
          <span 
            slot="label"
            class="chip-set__label"
          >
            @if (isTagNameWithBrackets(tag.name[currentLang])) {
              {{ getTagNameWithoutBrackets(tag.name[currentLang]) }}
              <span style="font-weight: 400;">
                ({{ getBracketTagContent(tag.name[currentLang]) }})
              </span>
            } @else {
              {{ tag.name[currentLang] }}
            }
          </span>
        </ci-suggestion-chip-outline>
      }
    </ci-chip-set>
  </div>

  @if(isSeeMoreButtonVisible()) {
    <button 
      class="singleTags__see-more-button"
      (click)="handleSeeMoreClick()"
      [attr.icon-name]="this.isExpanded ? 'upward' : 'downward'" 
      tabindex="0"
    >   
      <span 
        class="see-more-button__title ci-heading-h6-semibold"
        [style.width.px]="this.isExpanded ? 84 : 64"
      >
        {{ (this.isExpanded ? 'Ver menos' : 'Ver más') | translate }}
      </span>
      
      <ci-icon 
        class="see-more-button__arrow-icon"
        type="svg" 
        [attr.name]="this.isExpanded ? 'upward' : 'downward'" 
        scale="1x"
      ></ci-icon>
    </button>
  }
</section>
